import React from 'react';

export const LinkedInLogo = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.273459 6.08347H3.88729V18.0186H0.273459V6.08347ZM2.10949 0.0267334C3.27465 0.0267334 4.2193 0.971871 4.2193 2.13802C4.2193 3.30417 3.27465 4.2493 2.10949 4.2493C0.944336 4.2493 0 3.30417 0 2.13802C0 0.971871 0.944647 0.0267334 2.10949 0.0267334ZM9.44242 7.7066C11.7787 4.62648 18 4.93696 18 10.7724V18.0267H14.3522L14.3619 11.6358C14.3619 7.7811 9.7788 8.55915 9.61964 11.4794V18.0186H6.00613V6.08347H9.44242V7.7066Z" />
  </svg>
);
